import 'jquery-inview';

/**
 * スクロールアニメーション
 */
export class Inview {

  /**
   * 対象の要素オブジェクト
   */
  private readonly $element: JQuery;

  /**
   * 遅延時間（ミリ秒）
   */
  private readonly delayTime: number;

  /**
   * コンストラクタ
   * @param element 対象の要素セレクタ
   * @param delay 遅延時間（ミリ秒）
   */
  constructor(element: string, delay: number = 300) {
    this.$element = $(element);
    this.delayTime = delay;
    this.init();
  }

  /**
   * 初期化
   */
  private init(): void {
    this.$element.each((index: number, element: Element): void => {
      $(element).on('inview', this.inviewListener);
    });
  }

  /**
   * インビューイベントリスナー
   * @param event イベントオブジェクト
   * @param isInView 要素が表示されているかの真偽値
   * @param visiblePartX x座標
   * @param visiblePartY y座標
   */
  private inviewListener = (event: JQueryEventObject, isInView: boolean, visiblePartX: number, visiblePartY: number): void => {
    const $this: JQuery = $(event.currentTarget);

    if (isInView) {
      setTimeout(function(): void {
        $this.addClass('is-active');
      }, this.delayTime);
    }
  }

}
